import React from 'react';

const Select = ({
    options = [],
    value,
    onChange,
    placeholder = 'Please select...',
    className = '',
    error = false,
    ...props
}) => {
    const baseClasses = `
    !flex !w-full !min-w-0 !flex-1 !resize-none !overflow-hidden !rounded-xl 
    !text-[#121317] focus:!outline-0 focus:!ring-0 !border !bg-white !h-14 
    !placeholder:text-[#676c83] !pl-[15px] !pr-[48px] !py-[15px] !text-base !font-normal !leading-normal !cursor-pointer
    !bg-[image:url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720px%27 height=%2720px%27 fill=%27rgb(103,108,131)%27 viewBox=%270 0 256 256%27%3e%3cpath d=%27M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z%27/%3e%3c/svg%3e')] !bg-no-repeat !bg-[right_16px_center] !bg-[length:20px_20px]
  `;

    const borderClasses = error ? '!border-red-500 focus:!border-red-500' : '!border-[#dddee4] focus:!border-[#dddee4]';

    return (
        <select
            className={`${baseClasses} ${borderClasses} ${className}`}
            value={value}
            onChange={(e) => onChange && onChange(e.target.value)}
            {...props}
        >
            <option value="">{placeholder}</option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.title || option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;
